import { getProfileService } from "../../services";
import {
  setError,
  setFetching,
} from "../../shared/request/actions/requestActions";
import {
  getSmsNotificationSetting,
  updateProfileService,
  updateSmsNotificationSetting,
} from "../services";
import {
  RESET_PROFILE,
  SET_ACCOUNT_ACCESS,
  SET_NO_ACCOUNTS,
  SET_PROFILE,
  SET_PROFILE_ID,
  SET_PROFILE_PICTURE,
  SET_SMS_SETTING,
} from "./actionsTypes";

export const setSmsSetting = (setting) => ({
  type: SET_SMS_SETTING,
  payload: setting,
});

export const setProfile = (profile) => ({
  type: SET_PROFILE,
  payload: profile,
});

export const setProfileId = (participantProfileId) => ({
  type: SET_PROFILE_ID,
  payload: { participantProfileId },
});

export const setAccountAccess = (access) => ({
  type: SET_ACCOUNT_ACCESS,
  payload: access,
});

export const setNoAccounts = () => ({
  type: SET_NO_ACCOUNTS,
});

export const resetProfile = () => ({
  type: RESET_PROFILE,
});

export const setProfilePicture = (profilePicturePath) => ({
  type: SET_PROFILE_PICTURE,
  payload: profilePicturePath,
});

const widgetInformation = (data) => {
  let isError = false;
  let isProfileModalError = false;

  if (
    data.creditScore === null ||
    data.annualIncome === null ||
    data.yearsInTheCompany === null ||
    data.maritalStatusId === null ||
    data.maritalStatusId === 0
  )
    isError = true;
  if (
    data.dateOfBirth === null ||
    data.genderId === null ||
    data.genderId === 0 ||
    data.maritalStatusId === 0 ||
    (data.mobile === null && data.workPhone === null) ||
    data.firstFinancialGoal === null ||
    data.annualIncome === null
  )
    isProfileModalError = true;
  if (data.hasSpouse) {
    if (!data.spouseAnnualIncome || !data.spouseRetirementAge) isError = true;
  }
  if (
    data.retirementDate === null ||
    data.firstFinancialGoal === null ||
    data.mobile === null
  )
    isError = true;

  return {
    isError,
    isProfileModalError,
    isReady: true,
  };
};

export const asyncGetProfile = (id) => async (dispatch) => {
  dispatch(setFetching({ isFetching: true }));
  try {
    const { data: profileDetails } = await getProfileService(id);

    const profileStatus = widgetInformation(profileDetails.data);

    dispatch(
      setProfile({
        ...profileDetails.data,
        ...profileStatus,
      })
    );
  } catch (error) {
    let message = "";
    if (error.response?.data) {
      message = error.response.data.errors.length
        ? error.response.data.errors.toString()
        : error.response.data.warnings.toString();
    } else message = "Unexpected error";

    dispatch(setError({ isOpen: true, message, type: "error" }));
  } finally {
    dispatch(setFetching({ isFetching: false }));
  }
};

export const asyncUpdateProfile = (data) => async (dispatch) => {
  dispatch(setFetching({ isFetching: true }));
  try {
    const response = await updateProfileService(data);
    dispatch(asyncGetProfile(data.get("participantProfileId")));
    if (response.data.warnings.length) {
      dispatch(
        setError({
          isOpen: true,
          message: response.data.warnings.toString(),
          type: "success",
        })
      );
    } else {
      dispatch(
        setError({
          isOpen: true,
          message: "The participant´s information was saved successfully",
          type: "success",
        })
      );
    }
  } catch (error) {
    let message = "";
    if (error?.response?.data) {
      message = error.response.data.errors.length
        ? error.response.data.errors.toString()
        : error.response.data.warnings.toString();
    } else message = "Unexpected error";

    dispatch(setError({ isOpen: true, message, type: "error" }));
  } finally {
    dispatch(setFetching({ isFetching: false }));
  }
};

export const asyncGetSmsNotificationSetting =
  (profileId) => async (dispatch) => {
    try {
      const { data: response } = await getSmsNotificationSetting(profileId);
      dispatch(setSmsSetting(response?.data?.enabled ?? false));
    } catch (error) {
      dispatch(setSmsSetting(false));
      if (error?.response?.data) {
        dispatch(
          setError({
            isOpen: true,
            type: "error",
            message: error.response.data.errors.length
              ? error.response.data.errors.toString()
              : error.response.data.warnings.toString(),
          })
        );
      }
    }
  };

export const asyncUpdateSmsNotification = (settings) => async (dispatch) => {
  dispatch(setFetching({ isFetching: true }));
  try {
    const { data: response } = await updateSmsNotificationSetting(settings);
    if (response.data) {
      dispatch(setSmsSetting(response.data.enabled));
      dispatch(
        setError({
          isOpen: true,
          message: "Sms notification setting was updated successfully",
          type: "success",
        })
      );
    } else {
      dispatch(
        setError({
          isOpen: true,
          message: "Sms notification setting was not updated",
          type: "error",
        })
      );
    }
  } catch (error) {
    let message = "Sms notification setting was not updated";
    if (error.response.data) {
      message = error.response.data.errors.length
        ? error.response.data.errors.toString()
        : error.response.data.warnings.toString();
    } else message = "Unexpected error";
    dispatch(setError({ isOpen: true, message, type: "error" }));
  } finally {
    dispatch(setFetching({ isFetching: false }));
  }
};
